module.exports = __webpack_public_path__ + "img/waves-birdseye.2a45fedf.jpg";